import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiMessageSquare, FiX, FiCpu } = FiIcons;
const BOT_LINK = "https://t.me/sc4apps_bot";

const FloatingBot = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setIsVisible(true), 2000);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="fixed bottom-6 right-6 z-[60] flex flex-col items-end gap-4 pointer-events-none">
      <AnimatePresence>
        {isVisible && (
          <motion.div
            initial={{ opacity: 0, y: 20, scale: 0.9, x: 20 }}
            animate={{ opacity: 1, y: 0, scale: 1, x: 0 }}
            exit={{ opacity: 0, scale: 0.9, x: 20 }}
            className="pointer-events-auto max-w-[280px] bg-[#1A1A1C] border border-yellow-500/30 rounded-2xl p-4 shadow-[0_20px_50px_rgba(0,0,0,0.5)] relative mb-2"
          >
            <button 
              onClick={() => setIsVisible(false)}
              className="absolute -top-2 -right-2 w-6 h-6 bg-zinc-800 border border-white/10 rounded-full flex items-center justify-center text-slate-400 hover:text-white transition-colors"
            >
              <SafeIcon icon={FiX} className="text-xs" />
            </button>
            
            <div className="flex gap-3">
              <div className="w-10 h-10 shrink-0 rounded-full bg-yellow-500 flex items-center justify-center text-black shadow-[0_0_15px_rgba(234,179,8,0.3)]">
                <SafeIcon icon={FiCpu} className="text-xl" />
              </div>
              <div>
                <p className="text-white font-bold text-sm mb-1">Need help? We've got you covered! 🤖</p>
                <p className="text-slate-400 text-[11px] leading-relaxed mb-3">
                  Have an issue? Get in touch with our brand-new AI support bot. Available 24/7! 🚀
                </p>
                <a 
                  href={BOT_LINK}
                  target="_blank"
                  rel="noreferrer"
                  className="inline-block w-full text-center bg-yellow-500 hover:bg-yellow-400 text-black font-black text-[10px] py-2 rounded-lg transition-colors uppercase tracking-wider"
                >
                  Contact AI Bot
                </a>
              </div>
            </div>
          </motion.div>
        )}
      </AnimatePresence>

      <motion.a
        href={BOT_LINK}
        target="_blank"
        rel="noreferrer"
        whileHover={{ scale: 1.1 }}
        whileTap={{ scale: 0.9 }}
        className="pointer-events-auto w-14 h-14 bg-yellow-500 rounded-full flex items-center justify-center text-black shadow-[0_10px_30px_rgba(234,179,8,0.4)] relative group"
      >
        <div className="absolute inset-0 rounded-full bg-yellow-500 animate-ping opacity-20 group-hover:hidden"></div>
        <SafeIcon icon={FiMessageSquare} className="text-2xl" />
      </motion.a>
    </div>
  );
};

export default FloatingBot;